/**
 * Constants cho ứng dụng quản lý đơn hàng
 * Tập trung tất cả dữ liệu tĩnh để dễ quản lý và cập nhật
 */

// Đơn vị cân nặng
export const WEIGHT_UNITS = {
  GRAM: 'g',
  KILOGRAM: 'kg'
} as const;

// Chuyển đổi đơn vị cân nặng
export const WEIGHT_CONVERSION = {
  GRAM_TO_KG: 1000,
  KG_TO_GRAM: 0.001
} as const;

// Danh sách tỉnh/thành phố
export const PROVINCES = [
  { value: 'TP.HCM', label: 'TP.HCM' },
  { value: 'Hà Nội', label: 'Hà Nội' },
  { value: 'Đà Nẵng', label: 'Đà Nẵng' },
  { value: 'Cần Thơ', label: 'Cần Thơ' },
  { value: 'Hải Phòng', label: 'Hải Phòng' }
] as const;

// Danh sách quận/huyện theo tỉnh
export const DISTRICTS = {
  'TP.HCM': [
    { value: 'Quận 1', label: 'Quận 1' },
    { value: 'Quận 3', label: 'Quận 3' },
    { value: 'Quận 10', label: 'Quận 10' }
  ],
  'Hà Nội': [
    { value: 'Ba Đình', label: 'Ba Đình' },
    { value: 'Hoàn Kiếm', label: 'Hoàn Kiếm' },
    { value: 'Đống Đa', label: 'Đống Đa' },
    { value: 'Hai Bà Trưng', label: 'Hai Bà Trưng' }
  ]
} as const;

// Danh sách phường/xã theo quận
export const WARDS = {
  'Quận 1': [
    { value: 'Phường 1', label: 'Phường 1' },
    { value: 'Phường 2', label: 'Phường 2' },
    { value: 'Phường 3', label: 'Phường 3' }
  ],
  'Đống Đa': [
    { value: 'Láng Thượng', label: 'Láng Thượng' },
    { value: 'Láng Hạ', label: 'Láng Hạ' }
  ]
} as const;

// Danh sách dịch vụ vận chuyển
export const SHIPPING_SERVICES = [
  { value: 'Hỏa tốc', label: 'Hỏa tốc (4-6h)', estimatedTime: '4-6h' },
  { value: 'Nhanh', label: 'Nhanh (24h)', estimatedTime: '24h' },
  { value: 'Tiết kiệm', label: 'Tiết kiệm (48-72h)', estimatedTime: '48-72h' }
] as const;

// Số lượng kiện hàng tối đa
export const MAX_PACKAGE_COUNT = 20;

// Trạng thái đơn hàng
export const ORDER_STATUS = {
  DRAFT: 'Bản nháp',
  PENDING: 'Chờ xử lý',
  PROCESSING: 'Đang xử lý',
  IN_TRANSIT: 'Đang vận chuyển',
  DELIVERED: 'Đã giao',
  CANCELLED: 'Đã hủy'
} as const;

// Màu sắc cho trạng thái
export const STATUS_COLORS = {
  [ORDER_STATUS.DRAFT]: 'bg-gray-100 text-gray-800',
  [ORDER_STATUS.PENDING]: 'bg-yellow-100 text-yellow-800',
  [ORDER_STATUS.PROCESSING]: 'bg-blue-100 text-blue-800',
  [ORDER_STATUS.IN_TRANSIT]: 'bg-purple-100 text-purple-800',
  [ORDER_STATUS.DELIVERED]: 'bg-green-100 text-green-800',
  [ORDER_STATUS.CANCELLED]: 'bg-red-100 text-red-800'
} as const;

// Validation rules
export const VALIDATION_RULES = {
  PHONE: /^[0-9]{10,11}$/,
  WEIGHT_MIN: 1, // gram
  WEIGHT_MAX: 50000, // gram (50kg)
  DECLARED_VALUE_MAX: 100000000, // 100 triệu VNĐ
  CUSTOM_ORDER_ID_MAX_LENGTH: 50
} as const;

// Error messages
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'Trường này là bắt buộc',
  INVALID_PHONE: 'Số điện thoại không hợp lệ',
  INVALID_WEIGHT: 'Cân nặng phải từ 1g đến 50kg',
  INVALID_DECLARED_VALUE: 'Giá trị khai báo không được vượt quá 100 triệu VNĐ',
  CUSTOM_ORDER_ID_TOO_LONG: 'Mã đơn hàng không được vượt quá 50 ký tự'
} as const;

// Success messages
export const SUCCESS_MESSAGES = {
  ORDER_CREATED: 'Đơn hàng đã được tạo thành công',
  ORDER_UPDATED: 'Đơn hàng đã được cập nhật thành công',
  DRAFT_SAVED: 'Bản nháp đã được lưu thành công'
} as const;